// extracted by mini-css-extract-plugin
module.exports = {"backButton":"styles_backButton__K_hqI","tapTarget":"styles_tapTarget__wdqDR"};